import React, { useState } from "react";

import { Button, Stack, TextField } from "@mui/material";

interface Props {
  currentValue: number | null;
  onSubmit: (result: { value: number | null }) => void;
  onCancel: () => void;
}

export const TagValuePrompt: React.FC<Props> = ({ currentValue, onSubmit, onCancel }) => {
  const [raw, setRaw] = useState<string>(currentValue == null ? "" : String(currentValue));

  const trimmed = raw.trim();
  const parsed = trimmed === "" ? null : Number(trimmed);
  const invalid = trimmed !== "" && Number.isNaN(parsed);

  const submit = () => {
    if (!invalid) onSubmit({ value: parsed });
  };

  return (
    <Stack sx={{ padding: "24px", gap: "20px", minWidth: "320px" }}>
      <TextField
        label="Value"
        value={raw}
        autoFocus
        error={invalid}
        helperText={invalid ? "Enter a valid number" : undefined}
        onChange={(e) => setRaw(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") submit();
        }}
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: "8px",
            "& fieldset": { borderColor: "#7b92a9" }
          }
        }}
      />
      <Stack direction="row" justifyContent="flex-end" gap="8px">
        <Button
          onClick={onCancel}
          sx={{
            borderRadius: "32px",
            border: "1px solid #7b92a9",
            color: "#071f35",
            textTransform: "none",
            padding: "4px 16px",
            fontSize: "16px",
            fontWeight: 400,
            lineHeight: "24px"
          }}
        >
          Cancel
        </Button>
        <Button
          disabled={invalid}
          onClick={submit}
          sx={{
            borderRadius: "32px",
            bgcolor: "#071f35",
            color: "white",
            textTransform: "none",
            padding: "4px 16px",
            fontSize: "16px",
            fontWeight: 400,
            lineHeight: "24px",
            "&:hover": { bgcolor: "#0a2a45" },
            "&:disabled": { bgcolor: "#bac7ce", color: "white" }
          }}
        >
          Save
        </Button>
      </Stack>
    </Stack>
  );
};
